(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.currentScript
      ? document.currentScript.closest('.product-carousel')
      : null;

    // Fallback: initialize every carousel on the page (theme editor safe)
    const carousels = root ? [root] : document.querySelectorAll('.product-carousel');

    carousels.forEach(initCarousel);

    function initCarousel(carousel) {
      if (carousel.dataset.carouselInit === 'true') return;
      carousel.dataset.carouselInit = 'true';

      const track = carousel.querySelector('[data-carousel-track]');
      const slides = carousel.querySelectorAll('[data-carousel-slide]');
      const prevBtn = carousel.querySelector('[data-carousel-prev]');
      const nextBtn = carousel.querySelector('[data-carousel-next]');
      const dotsWrap = carousel.querySelector('[data-carousel-dots]');
      const interval = parseInt(carousel.dataset.autoplayInterval, 10) || 5000;

      if (!track || slides.length <= 1) return;

      let current = 0;
      let timer = null;

      // Build dots
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-carousel__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', () => {
          goTo(i);
          restart();
        });
        dotsWrap.appendChild(dot);
      });
      const dots = dotsWrap.querySelectorAll('.product-carousel__dot');

      function goTo(index) {
        current = (index + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + current * 100 + '%)';
        dots.forEach((d, i) =>
          d.setAttribute('aria-selected', i === current ? 'true' : 'false')
        );
      }

      function next() {
        goTo(current + 1);
      }

      function prev() {
        goTo(current - 1);
      }

      function start() {
        stop();
        timer = setInterval(next, interval);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      function restart() {
        stop();
        start();
      }

      prevBtn.addEventListener('click', () => {
        prev();
        restart();
      });
      nextBtn.addEventListener('click', () => {
        next();
        restart();
      });

      // Pause while the user is interacting
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);

      // Touch swipe support
      let startX = 0;
      track.addEventListener(
        'touchstart',
        (e) => {
          startX = e.touches[0].clientX;
          stop();
        },
        { passive: true }
      );
      track.addEventListener(
        'touchend',
        (e) => {
          const delta = e.changedTouches[0].clientX - startX;
          if (Math.abs(delta) > 40) {
            delta < 0 ? next() : prev();
          }
          start();
        },
        { passive: true }
      );

      // Pause when tab is hidden (saves battery, keeps timing honest)
      document.addEventListener('visibilitychange', () => {
        document.hidden ? stop() : start();
      });

      goTo(0);
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
